<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="12">
        <div v-if="parkPosition === 'DX'" class="text-right" :style="`width:${(100 * maxLengthTrue) / maxLengthFactor}%; min-width:${(600 * maxLengthTrue) / maxLengthFactor}px; right: 0px`">
          {{ $t("b") }} {{ binario.numero }}
        </div>
        <div v-else>
          {{ $t("b") }} {{ binario.numero }}
        </div>
      </v-col>
    </v-row>
    <v-row class="rail-row" no-gutters id="`binario-${binario.id}`" @click="selectingRail">
      <div
        class="rail"
        :selected="selectedAttributeValue"
        :style="`width:${(100 * binario.lunghezza) / maxLengthFactor}%; min-width:${(600 * binario.lunghezza) / maxLengthFactor}px; left: ${parkPosition === 'DX'?((100 * (maxLengthTrue - binario.lunghezza)) / maxLengthFactor):0}%`"
      ></div>

      <wagon
        v-for="(carroConvoglio, index) in carriConvoglio"
        :deltaBinario="200"
        :active="index === activeIndex"
        :index="index"
        :key="carroConvoglio.id"
        :carroConvoglio="carroConvoglio"
        :maxLengthFactor="maxLengthFactor"
        :utiSearchParam="utiSearchParam"
        :wagonSearchParam="wagonSearchParam"
        :plannedShowing="plannedShowing"
        :features="features"
        :yardShowing="yardShowing"
        :convoglioSel="convoglioSel"
        :numBinario="binario.numero"
        :parkPosition="binario.parcoBinari.posizioneParco"
        :parkPositionWagon="parkPosition"
        :filtered-ships="filteredShips"
        :ship-filter-enabled="shipFilterEnabled"
        :ship-colors="shipColors"
        :isConvoglioInLavorazione="convogliInLavorazione.includes(carroConvoglio.convoglioId)"
        @set-active="activeIndex = $event"
      />

      <div
          :class="['rail-distance-cntr', { 'mirror-cntr': parkPosition === 'DX', 'rail-distance-cntr': parkPosition === 'SX' }]"
          :style="`width:${(100 * binario.lunghezza) / maxLengthFactor}%;min-width:${(600 * binario.lunghezza) / maxLengthFactor}px; left: ${parkPosition === 'DX'?((100 * (maxLengthTrue - binario.lunghezza)) / maxLengthFactor):0}%`">
          <div v-for="(distanceMarker, index) in getRailIntervalList(binario, lengthInterval)" :key="index"
            class="rail-distance"
            :style="`width:${distanceMarker.dm}%;font-size:${(((3 * maxLengthFactor) / 100) * lengthInterval) / maxLengthFactor}rem;`">
            <span :class="{ 'mirror-text': parkPosition === 'DX' }">
              {{ distanceMarker.length }}
            </span>
          </div>
        </div>
    </v-row>
  </v-container>
</template>

<script>
import _ from "lodash";
import multiParkManagementMixins from "../../mixins/MultiParkManagementMixins";
import convoyVisualizationMixins from "./mixins/convoyVisualizationMixins";
import wagon from "./Wagon";

export default {
  name: "railSpatialVisualization",
  components: {
    wagon,
  },
  props: {
    binario: {
      type: Object,
      required: true,
    },
    maxLengthFactor: {
      type: Number,
      default: 200,
    },
    maxLengthTrue: {
      type: Number,
      default: 200,
    },
    lengthInterval: {
      type: Number,
      default: 10,
    },
    convogli: {
      type: Array,
      default: () => [],
    },
    convoglioSel: {
      type: Object,
      required: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    utiSearchParam: {
      type: String,
      default: "",
    },
    wagonSearchParam: {
      type: String,
      default: "",
    },
    plannedShowing: {
      type: Boolean,
      default: false,
    },
    features: {
      type: Array,
      default: () => [],
    },
    yardShowing: {
      type: Boolean,
      default: false,
    },
    parkPosition: {
      type: String,
      default: "SX",
    },
    filteredShips: {
      type: Array,
      default: () => [],
    },
    shipFilterEnabled: {
      type: Boolean,
      default: false,
    },
    shipColors: {
      type: Object,
      default: () => ({}),
    },
    scaleFactor: {
      type: Number,
      default: 1.0,
    },
  },
  data() {
    return {
      activeIndex: 0,
    };
  },
  mixins: [multiParkManagementMixins, convoyVisualizationMixins],
  mounted() {},
  computed: {
    maxRailLength() {
      const maxLengthRail = _.maxBy(this.binari, (b) => {
        return b.lunghezza;
      });
      return maxLengthRail && maxLengthRail.lunghezza ? maxLengthRail.lunghezza : 0;
    },
    carriConvoglio() {
      let carriConvoglio = [];
      this.convogli.forEach((convoglio) => {
        if (convoglio.listCarri) {
          let pos = convoglio.posizioneBinario;
          convoglio.listCarri = this._.orderBy(convoglio.listCarri, [(cc) => cc.posizione]);
          convoglio.listCarri.forEach((cc) => {
            cc.dialog = false;
            cc.posizioneBinario = pos;
            cc.idConvoglio = convoglio.id;
            pos += this.getCarroLength(cc);
            carriConvoglio.push(cc);
          });
        }
      });
      return carriConvoglio;
    },
    selectedAttributeValue() {
      if (this.selected) {
        return true;
      }
      return false;
    },
    convogliInLavorazione() {
      var convogliInLavorazione = [];
      this.convogli.forEach((convoglio) => {
        if (convoglio.listCarri && convoglio.listCarri.length > 0) {
          let hasCaricato = false;
          let hasScaricato = false;

          convoglio.listCarri.forEach((carro) => {
            if (Array.isArray(carro.listUti)) {
              carro.listUti.forEach((uti) => {
                if (uti.stato === "CARICATO") hasCaricato = true;
                if (uti.stato === "SCARICATO") hasScaricato = true;
              });
            }
          });
          console.log("totalUti:", hasCaricato, "loadedOrUnloaded:", hasScaricato);
          if (hasCaricato && hasScaricato) {
            convogliInLavorazione.push(convoglio.id);
          }
        }
      });
      return convogliInLavorazione;
    }
  },
  methods: {
    selectingRail() {
      this.$eventBus.$emit("selectingRail", this.binario.id);
    },
    getRailIntervalList(binario, lengthInterval) {
      let lRes = binario.lunghezza;
      const resList = [];
      for (let i = 0; i < Math.round(binario.lunghezza / lengthInterval); i++) {
        if (lRes > lengthInterval) {
          resList.push({
            dm: (100 * lengthInterval) / binario.lunghezza,
            length: lengthInterval * (i + 1),
          });
        } else {
          resList.push({ dm: (100 * lRes) / binario.lunghezza, length: binario.lunghezza });
        }
        lRes -= lengthInterval;
      }
      return resList;
    },
  },
};
</script>

<style scoped>
.rail-row {
  z-index: 1;
  height: 40px;
  position: relative;
}

.flex-row-reverse {
  display: flex;
  flex-direction: row-reverse;
  z-index: 1;
  height: 40px;
  position: relative;
}

.flex-rail-label-reverse {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}

.rail {
  z-index: 0;
  position: absolute;
  height: 40px;
  margin-top: 20px;
  border: 2px solid #aaaaaa;
}

.rail[selected="selected"] {
  background: #d3d3d3;
}

.rail-distance-cntr {
  z-index: 1;
  position: absolute;
  margin-top: 25px;
}

.rail-distance {
  height: 55px;
  margin-top: -20px;
  float: left;
  border-right: 1px solid #aaaaaa;
  text-align: right;
  color: rgb(99, 99, 99);
  padding-right: 1px;
}

.mirror-cntr {
  transform: scaleX(-1);
}

.mirror-text {
  transform: scaleX(-1);
  display: inline-block;
}

/* .working-icon {
  font-size: 20px;
  cursor: pointer;
} */

.wagon-reverse {
  flex-direction: row-reverse;
}

.wagon {
  position: absolute;
  height: 40px;
  margin-top: 20px;
  border-right: 2px dashed #1b1b0f;
  background: rgba(105, 105, 105, 0.5);
  overflow: visible;
}
</style>
